/* eslint-disable no-unused-vars */
import Register from "./components/Register";
import ipConfig from "./ipConfig.json";
import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import Products from "./components/Products";
import Checkout from "./components/Checkout";
import Thanks from "./components/Thanks";
import React from "react";
import { ThemeProvider } from "@mui/system";
import theme from "./theme";


// export const config = {
//   endpoint: `http://localhost:8082/api/v1`,
// }
// https://ahmed-qkart-frontend.herokuapp.com/
export const config = {
  endpoint: `https://ahmed-qkart-frontend.herokuapp.com/api/v1`,
}
// export const config = {
//   endpoint: `http://${ipConfig.workspaceIp}:8082/api/v1`,
// };

function App() {
  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <div className="App">
          {/* TODO: CRIO_TASK_MODULE_LOGIN - To add configure routes and their mapping */}
          <Switch>
            <Route path="/register" >
              <Register />
            </Route>
            <Route path="/login" component={Login} />
            <Route path="/checkout" component={Checkout} />
            <Route path="/thanks" component={Thanks} />
            <Route exact path="/" >
              <Products />
            </Route>
          </Switch>
        </div>
      </ThemeProvider>
    </React.StrictMode>
  )
}

export default App;
